module.exports = __webpack_public_path__ + "img/dark_wheelchair.8cdaa165.png";